var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 15.5V13.25C16.25 13.0511 16.329 12.8603 16.4697 12.7197C16.6103 12.579 16.8011 12.5 17 12.5H26C26.1989 12.5 26.3897 12.579 26.5303 12.7197C26.671 12.8603 26.75 13.0511 26.75 13.25V23.75C26.75 23.9489 26.671 24.1397 26.5303 24.2803C26.3897 24.421 26.1989 24.5 26 24.5H23.75V26.75C23.75 27.164 23.4125 27.5 22.9948 27.5H14.0052C13.9063 27.5006 13.8083 27.4816 13.7167 27.4442C13.6252 27.4068 13.5419 27.3517 13.4717 27.282C13.4016 27.2123 13.3458 27.1294 13.3078 27.0381C13.2697 26.9468 13.2501 26.8489 13.25 26.75L13.2523 16.25C13.2523 15.836 13.5897 15.5 14.0067 15.5H16.25ZM14.7515 17L14.75 26H22.25V17H14.7515ZM17.75 15.5H23.75V23H25.25V14H17.75V15.5ZM16.25 19.25H20.75V20.75H16.25V19.25ZM16.25 22.25H20.75V23.75H16.25V22.25Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvIcon1);
export default __webpack_public_path__ + "static/media/adv_icon1.8429bc8374ee61ce58957203e96359e5.svg";
export { ForwardRef as ReactComponent };